<template>
	<div>顾问咨询</div>
</template>

<script>
	export default {
		name: 'QualificationConsulting',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
